import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';
import ErrorMessage from '@spp/ui-error-message';
import { themer } from '@spp/theme-provider';

const GenericError = ({ statusCode, theme }) => {
    const {
        errorMessages: {
            notfound: { heading: notFoundHeading = '', message: notFoundMessage = '' } = {},
            generic: { heading: genericHeading = '', message: genericMessage = '' } = {},
        } = {},
    } = config;

    let error;
    let title;
    if (statusCode === 404) {
        error = (
            <ErrorMessage
                heading={notFoundHeading}
                message={notFoundMessage}
                statusCode={404}
                theme={theme}
            />
        );
        title = `VG - ${notFoundMessage}`;
    } else {
        error = (
            <ErrorMessage
                heading={genericHeading}
                message={genericMessage}
                statusCode={statusCode}
                theme={theme}
            />
        );
        title = `VG - ${genericMessage}`;
    }

    return (
        <div className={theme.root}>
            <Helmet title={title} />
            <main id="main" role="main" className={theme.contentContainer}>
                {error}
                <p>
                    Gå tilbake til <a href="/">forsiden</a>.
                </p>
            </main>
        </div>
    );
};

GenericError.propTypes = {
    statusCode: PropTypes.number.isRequired,
    theme: PropTypes.shape({
        notfound: PropTypes.string,
    }),
};

GenericError.defaultProps = {
    statusCode: 404,
    theme: {},
};

export default themer('@vg/generic-error')(GenericError);



/** WEBPACK FOOTER **
 ** ./src/screens/error/index.js
 **/